(() => {
  if (!document.querySelector('.hcc')) return;
  const updateCountdowns = () => {
    document.querySelectorAll('[data-hcc-countdown]').forEach(element => {
      const end = Date.parse(element.dataset.endsAt);
      if (!Number.isFinite(end)) return;
      const hours = Math.max(0, Math.ceil((end - Date.now()) / 3600000));
      element.textContent = hours === 0
        ? element.dataset.ended
        : (hours === 1 ? element.dataset.one : element.dataset.other).replace('__HOURS__', String(hours));
    });
  };
  updateCountdowns();
  setInterval(updateCountdowns, 30000);
  document.addEventListener('visibilitychange', updateCountdowns);
  document.addEventListener('shopify:section:load', updateCountdowns);
  const selector = '.hcc .product-list .product-item__primary-image, .hcc .product-list .product-item__secondary-image';
  const imageSelector = selector;
  const processed = new WeakMap();
  const cache = new Map();

  function measure(image) {
    const ratio = Math.min(1, 256 / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * ratio));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * ratio));
    const context = canvas.getContext('2d', { willReadFrequently: true });
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const { data } = context.getImageData(0, 0, canvas.width, canvas.height);
    const background = (offset) => data[offset + 3] < 24 || (
      Math.min(data[offset], data[offset + 1], data[offset + 2]) > 236 &&
      Math.max(data[offset], data[offset + 1], data[offset + 2]) -
        Math.min(data[offset], data[offset + 1], data[offset + 2]) < 22
    );
    const corners = [0, (canvas.width - 1) * 4,
      (canvas.height - 1) * canvas.width * 4, (canvas.width * canvas.height - 1) * 4];
    if (corners.some(offset => !background(offset))) return null;
    let left = canvas.width, top = canvas.height, right = -1, bottom = -1;
    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        if (background((y * canvas.width + x) * 4)) continue;
        left = Math.min(left, x);
        right = Math.max(right, x);
        top = Math.min(top, y);
        bottom = Math.max(bottom, y);
      }
    }
    if (right < left || bottom < top) return null;
    const side = Math.max(right - left + 1, bottom - top + 1) / 0.92;
    if (side < Math.max(canvas.width, canvas.height) / 4) return null;
    return {
      width: 100 * canvas.width / side,
      height: 100 * canvas.height / side,
      left: 50 - 100 * ((left + right + 1) / 2) / side,
      top: 50 - 100 * ((top + bottom + 1) / 2) / side
    };
  }

  async function fit(image) {
    if (!image.complete || !image.naturalWidth || !image.matches(selector) || image.dataset.hpdSrc) return;
    const source = image.currentSrc || image.src;
    if (!source || source.startsWith('data:') || processed.get(image) === source) return;
    processed.set(image, source);
    image.removeAttribute('data-hpd-ready');
    try { await image.decode(); } catch { processed.delete(image); return; }
    if ((image.currentSrc || image.src) !== source) return;
    if (!cache.has(source)) {
      if (cache.size > 80) cache.clear();
      let box = null;
      try { box = measure(image); } catch { /* Keep the centered contain fallback. */ }
      cache.set(source, box);
    }
    const box = cache.get(source);
    if (processed.get(image) !== source || !image.isConnected) return;
    if (box) {
      for (const [key, value] of Object.entries(box)) image.style.setProperty(`--hpd-image-${key}`, `${value.toFixed(4)}%`);
      image.dataset.hpdFitted = 'true';
    } else {
      for (const key of ['width', 'height', 'left', 'top']) image.style.removeProperty(`--hpd-image-${key}`);
      image.removeAttribute('data-hpd-fitted');
    }
    image.dataset.hpdReady = 'true';
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(imageSelector)) fit(root);
    root.querySelectorAll(imageSelector).forEach(fit);

  }
  scan(document);
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLImageElement) fit(event.target);
  }, true);
  document.addEventListener('error', event => {
    if (event.target instanceof HTMLImageElement && event.target.matches(selector)) {
      event.target.removeAttribute('data-hpd-ready');
      processed.delete(event.target);
    }
  }, true);
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(scan);
    }
  });
  const main = document.querySelector('.hcc');
  if (main) observer.observe(main, { childList: true, subtree: true });

  // Download hover images only when a pointer reaches the card.
  document.addEventListener('pointerover', event => {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const wrapper = event.target.closest?.('.hcc .product-item__image-wrapper--with-secondary');
    const image = wrapper?.querySelector('.product-item__secondary-image[data-hpd-src]');
    if (!image) return;
    const source = image.dataset.hpdSrc;
    const srcset = image.dataset.hpdSrcset;
    delete image.dataset.hpdSrc;
    delete image.dataset.hpdSrcset;
    image.srcset = srcset;
    image.src = source;
  });


})();

